
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const MAX_SCORE = 67;

export const ONE_ANSWER_QUESTION_ID = [ 1, 4, 5, 6, 7, 10 ];

export const OPTIMIZATION_RATINGS = [ 'critical', 'needs help', 'decent', 'good', 'optimized' ];

export const SURVEY_URL = 'https://info.biomerieux.com/clin_us_2025_lab-optimization-consultancy_survey';
